
const FeaturesSection = () => {
  const features = [
    {
      icon: 'ri-search-line',
      title: 'Content Analysis',
      description: 'Real-time content scanning with intelligent keyword optimization suggestions to improve your page rankings',
      bgColor: 'bg-gray-100',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Competitor Insights',
      description: 'Analyze top-ranking competitors and discover what makes their content perform better in search results',
      bgColor: 'bg-[#ede9fe]',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Instant Recommendations',
      description: 'Get actionable optimization steps immediately with clear priorities and implementation guidance',
      bgColor: 'bg-[#FFE8E0]',
    },
  ];

  return (
    <section className="py-20 bg-[#F9F7F4]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm text-gray-500 font-medium mb-3 tracking-wider">POWERFUL FEATURES</p>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            Everything You Need<br />To Rank Higher
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${feature.bgColor} rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer`}
            >
              <div className="w-14 h-14 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-4xl text-gray-900`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
